module.exports = __webpack_public_path__ + "static/media/you_are_here.224c8664.svg";